// ── Session hint cookie ──────────────────────────────────────────
// The real session lives in HttpOnly cookies (`sessionCookies.ts`), so the
// browser cannot tell a signed-in visitor from a guest without asking the API.
// This non-HttpOnly marker is written next to them purely so the client can
// skip `GET /v1/user/me` when there is provably no session to probe.
//
// It carries no identity and no token — only "cookies were issued". A stale
// marker costs one 401, which the boot probe already handles.

/** Non-HttpOnly marker cookie mirroring the HttpOnly session cookies. */
export const SESSION_HINT_COOKIE = "psyday_session";

/** Value written by the BFF; only its presence matters. */
export const SESSION_HINT_VALUE = "1";

/** True when the browser holds the session marker (false during SSR). */
export function hasSessionHint(): boolean {
  if (typeof document === "undefined") return false;
  const prefix = `${SESSION_HINT_COOKIE}=`;
  return document.cookie
    .split(";")
    .some((part) => part.trim().startsWith(prefix) && part.trim().length > prefix.length);
}

/**
 * Drop the marker client-side. Used when a 401 proves it outlived the session
 * (the server clears it too, but only on responses the browser actually makes).
 */
export function clearSessionHint(): void {
  if (typeof document === "undefined") return;
  document.cookie = `${SESSION_HINT_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
}
